import {test as testForEslint} from '@form8ion/eslint';

export default function codeStyleConfigured(options) {
  return testForEslint(options);
}
